<template>
  <div class="wc-row">
    <div class="wc-col">
      <VehicleChangeContainer
        :policyId="policyId"
        v-if="isFahrzeugwechselEnabled"
      ></VehicleChangeContainer>
      <Card
        v-else
        title="Technisches Update: Service temporär nicht verfügbar"
        :backgroundColorCard="true"
      >
        <template v-slot:content>
          <p>
            Aktuell steht dieser Service leider nicht zur Verfügung. Alternativ nutzen Sie
            bitte den Service unter folgender
            <a
              href="https://www.da-direkt.de/kfz-versichern/tarifrechner?execution=e1s1"
              target="_blank"
              rel="noopener"
              >Adresse</a
            >.<br /><br />Vielen Dank für Ihr Verständnis.
          </p>
        </template>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import VehicleChangeContainer from '@/componentsTenant/motor/vehiclechange/VehicleChangeContainer.vue'
import { Card } from 'de-zurich-ui-library'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { isTrue } from '@/utils/CommonUtils'

const route = useRoute()
const policyId = ref(route.params.policyId?.toString() ?? '')

const isFahrzeugwechselEnabled = ref(
  isTrue(globalThis.ENV_CONFIG?.FEATURE_FLAGS.MOTOR.ENABLE_MOTOR_FZW) ?? false
)
</script>

<style lang="scss" scoped>
/* empty */
</style>
